import {
  navigateTo,
  beginProcessAsync,
  getJsonNonCacheAsync,
} from 'shared/actions';
import {BASE_PATH} from 'shared/variables';
import {
  login,
  goToProfile,
  logout,
  refresh,
  partnerLogin
} from 'shared/auth/actions'; 

export const handleLogoutClick = () => dispatch => {
  dispatch(beginProcessAsync());
  logout();
};

export const handleLoginClick = () => dispatch => {
  dispatch(beginProcessAsync());
  login();
};

export const handleExitPartnerClick = () => dispatch => {
  dispatch(getJsonNonCacheAsync('authorization/exitPartner'))
  .then(() => {
    dispatch(beginProcessAsync());
    refresh();
    logout();
  });
};

export const handleUserClick = () => dispatch => {
  dispatch(goToProfile());
};

export const handleLogoClick = () => dispatch => {
  const pathExceptions = ['signin', BASE_PATH];
  const featurePath = window.location.pathname.split(/\//)
      .filter(x => x && !pathExceptions.includes(x));

  if(featurePath.length) {
    dispatch(navigateTo(`${featurePath[0]}`)); // navigate to the root of current feature
  } else {
    dispatch(navigateTo()); // navigate to root
  }
};

export const handlePartnerLoginClick = () => dispatch => {
  dispatch(beginProcessAsync());
  partnerLogin();
};



// WEBPACK FOOTER //
// ./src/features/shared/topBanner/actions.js